import { computed } from 'vue';
import Filter from '../../components/atoms/filter.vue';
import filterGrid from '../../../templates/components/molecules/filter-grid.html';
import { fetchCategories, state, url, slugify } from '../../core/vue/constants';

export default {
    template: filterGrid,
    components: {
        Filter,
    },

    setup() {
        fetchCategories();

        const filters = computed(() => {
            const options = [{
                label: `Alle disciplines (${state.pages.length})`,
                value: 'all',
            }];

            state.categories.forEach((category) => {
                if (category.linkedPagesCount > 0) {
                    options.push({
                        label: `${category.name} (${category.linkedPagesCount})`,
                        value: slugify(category.name),
                    });
                }
            });

            return [{
                name: 'disciplines',
                options: options,
            }];
        });

        const changeFilter = (filter) => {
            state.selectedFilter = filter;
            url.searchParams.set('c', filter.toLowerCase() !== 'all' ? filter : '');
            window.history.pushState(null, null, url.href);
        };

        const selectedFilter = computed(() => state.selectedFilter);

        return {
            filters,
            selectedFilter,
            changeFilter,
        };
    },
};
